import { format } from "date-fns";
import { nlBE, fr, enGB, de } from "date-fns/locale";
import { getPublicLocale, type Locale, type PublicLocale } from "consts/locale";

const dateFnsLocaleByPublicLocale: Record<PublicLocale, typeof nlBE> = {
  nl: nlBE,
  fr,
  en: enGB,
  de,
};

export const getToday = () => {
  const today = new Date();

  return format(today, "dd-MM-yyyy", { locale: nlBE });
};

export const getYesterday = () => {
  const today = new Date();
  const yesterday = today.getDate() - 1;
  const yesterdayDate = new Date(today.getFullYear(), today.getMonth(), yesterday);

  return format(yesterdayDate, "dd-MM-yyyy", { locale: nlBE });
};

export const getPreviousMonth = () => {
  const today = new Date();
  const prevMonth = today.getMonth() - 1;
  const prevMonthdate = new Date(today.getFullYear(), prevMonth, today.getDate());

  return format(prevMonthdate, "dd-MM-yyyy", { locale: nlBE });
};

export const getPreviousYear = () => {
  const today = new Date();
  const prevYear = today.getFullYear() - 1;
  const prevYearDate = new Date(prevYear, today.getMonth(), today.getDay());

  return format(prevYearDate, "dd-MM-yyyy", { locale: nlBE });
};

export const isoToDateString = (locale: Locale, iso: string, dateFormat?: string) =>
  format(new Date(iso), dateFormat || "d LLLL yyyy", {
    locale: dateFnsLocaleByPublicLocale[getPublicLocale(locale)],
  });
